<template>

  <v-container fluid fill-height pa-0>

    <v-layout column fill-height ma-0 pa-0>

      <v-layout fill-height ma-0 pa-0 >

        <v-flex xs12 >

          <v-layout fill-height column  ma-0 pa-0 >
           
            <scroll-area>

              <template slot="header">

                <v-toolbar class="primary" :height="56" flat dark>
                  <v-toolbar-title>
                    <span class="body-2 uppercase">{{ $t('configuration') }}</span>
                  </v-toolbar-title>
                </v-toolbar>

              </template>

              <template slot="body">

                <v-layout column fill-height justify-start ma-0 pa-0 >

                  <v-layout column fill-height  pa-1>
                    <scroll-table
                      :data="getTable"
                      :options="getOptions"
                      :reload="true"
                      @select="(payload) => onRowClick(payload)"
                      @value=""
                      @reload="()=>onReload()"
                      @remove="(payload) => onRemove(payload)"
                    />
                  </v-layout>

                  <v-layout v-if="show" column fill-height  pt-1>

                    <v-layout shrink class="primary" pa-0>
                      <v-toolbar class="primary" flat dark dense pa-0>
                        <v-toolbar-title>
                          <span class="body-2 uppercase">{{ model.obj.mac }}</span>
                        </v-toolbar-title>               
                      </v-toolbar>

                      <v-layout justify-end>
                        <v-tooltip dark color="secondary" bottom>
                          <v-btn icon flat slot="activator" 
                          :data-testid="$options.name + '__btn__' + 'close'"
                          @click.stop="() => onRowClick()">
                            <svg-icon
                              :color="'white'"
                              :name="'close'"
                              width="20"
                            />
                          </v-btn>
                          <span>{{ $t('close') }}</span>
                        </v-tooltip>
                      </v-layout>
                      
                    </v-layout>
                    
                    <v-layout fill-height  pa-0>
                      <v-flex xs4 >
                        <v-layout shrink ma-0 py-1 >
                          <v-flex xs12 >
                            <v-text-field
                              :data-testid="$options.name + '__text-field__' + 'name'"
                              v-model="model.obj.name"
                              light
                              auto-grow
                              outline
                              flat
                              :label="$t('name')"
                              hint
                              class="white"
                              background-color="primary"
                              hide-details
                              rows="1"
                            >
                            </v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-layout shrink ma-0 py-1 >
                          <v-flex xs12 >
                            <v-text-field
                              :data-testid="$options.name + '__text-field__' + 'ip-address'"
                              v-model="model.obj.ip"
                              light
                              auto-grow
                              outline
                              flat
                              :label="$t('ip-address')"
                              hint
                              class="white"
                              background-color="primary"
                              hide-details
                              rows="1"
                            >
                            </v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-layout shrink ma-0 py-1 >
                          <v-flex xs12 >
                            <v-text-field
                              :data-testid="$options.name + '__text-field__' + 'mask'"
                              v-model="model.obj.mask"
                              light
                              auto-grow
                              outline
                              flat
                              :label="$t('mask')"
                              hint
                              class="white"
                              background-color="primary"
                              hide-details
                              rows="1"
                            >
                            </v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-layout shrink ma-0 py-1 >
                          <v-flex xs12 >
                            <v-text-field
                              :data-testid="$options.name + '__text-field__' + 'gateway'"
                              v-model="model.obj.gateway"
                              light
                              auto-grow
                              outline
                              flat
                              :label="$t('gateway')"
                              hint
                              class="white"
                              background-color="primary"
                              hide-details
                              rows="1"
                            >
                            </v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-layout shrink ma-0 py-1 >
                          <v-flex xs12 >
                            <v-select
                              :data-testid="$options.name + '__select__' + 'image'"
                              v-model="model.obj.firmware"
                              light
                              auto-grow
                              :items="getFirmwares"
                              :label="'image'"
                              outline
                              hide-details
                              class="white"
                              background-color="primary"
                              rows="1"
                              height="56.48"
                            >
                            </v-select>
                          </v-flex>
                        </v-layout>

                        <v-layout v-if="treeActive.length && activeParent && activeParent.cls == 'cabinet'" shrink ma-0 py-1 >
                          <v-flex xs12 >
                            <v-select
                              :data-testid="$options.name + '__select__' + 'position'"
                              v-model="model.obj.position"
                              light
                              auto-grow
                              :items="getItems"
                              :label="activeParent.name + ' ' + $t('unit')"
                              :rules="[(value) => {checkPosition(value)}]"
                              item-text="name"
                              item-value="position"
                              item-disabled="busy"
                              outline
                              hide-details
                              class="white"
                              background-color="primary"
                              rows="1"
                              height="56.48"
                            >
                              <template v-slot:item="{ item, index }">
                                  <span>{{ item.busy ? $t(item.name) + ' (' + $t('busy') + ')' : $t(item.name)}}</span>
                              </template>
                              <template v-slot:selection="{ item, index }">
                                  <span>{{ $t(item.name) }}</span>
                              </template>
                            </v-select>
                          </v-flex>
                        </v-layout>

                        <v-layout v-if="treeActive.length && activeParent && activeParent.cls == 'cabinet'" shrink ma-0 py-1 >
                          <v-flex xs12 >
                            <v-select
                              :data-testid="$options.name + '__select__' + 'mount'"
                              v-model="model.obj.mount"
                              light
                              auto-grow
                              :items="['front', 'rear']"
                              :label="'side'"
                              outline
                              hide-details 
                              class="white"
                              background-color="primary"
                              rows="1"
                              height="56.48"
                            >
                              <template v-slot:item="{ item, index }">
                                  <span>{{ $t(item)}}</span>
                              </template>
                              <template v-slot:selection="{ item, index }">
                                  <span>{{ $t(item) }}</span>
                              </template>
                            </v-select>
                          </v-flex>
                        </v-layout>

                        <v-layout shrink v-if="treeActive.length && activeParent" justify-end ma-0 py-1 >
                          <v-flex shrink >
                            <v-layout ma-0 pa-0>
                              <v-layout ma-0 pa-0 justify-end>
                                <v-tooltip dark color="secondary" bottom>
                                  <v-btn small  color="primary" slot="activator" light text 
                                  :data-testid="$options.name + '__btn__' + 'save'"
                                  @click="() => submit()">{{$t('save changes')}}</v-btn>
                                  <span>{{ $t('save changes') }}</span>
                                </v-tooltip>
                              </v-layout>
                            </v-layout>
                          </v-flex>
                        </v-layout>

                      </v-flex>

                      <v-flex xs8 pl-1 pt-1>

                        <v-toolbar class="primary" flat dark dense>
                          <v-toolbar-title>
                            <span class="body-2 uppercase">{{ $t('disposition') }}</span>
                          </v-toolbar-title>
                        </v-toolbar>

                        <v-flex grow  style="height: 80%">
                          <scroll-area>
                            <template slot="body">
                              <v-treeview
                                :items="getTree"
                                :active.sync="treeActive"
                                :open.sync="treeOpened"
                                v-model="tree"
                                :load-children="loadChildren"
                                activatable
                                active-class="grey lighten-4 indigo--text"
                                selected-color="indigo"
                                return-object
                                loading-icon="autorenew"
                                expand-icon="expand_more"
                                on-icon="check_box"
                                off-icon="check_box_outline_blank"
                                indeterminate-icon="indeterminate_check_box"
                              >
                                <template v-slot:label="{ item, open }">
                                  <span class="caption font-weight-medium font-condensend">{{
                                    item.name
                                  }}</span>
                                </template>
                              </v-treeview>
                            </template>
                          </scroll-area>
                        </v-flex>                    
                        
                      </v-flex>
                    </v-layout>
                  </v-layout>

                </v-layout>

              </template>

            </scroll-area>

          </v-layout>
        </v-flex>
        
      </v-layout>

    </v-layout>

    <v-dialog v-model="dialog.open" max-width="1200px" v-if="dialog.open" style="position: relative">
      <ztp-card
        :data="getDialogData"
        @close="() => onDialogClose()"
      />
    </v-dialog>

  </v-container>

</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import scrollTable from '@/nms/components/partials/scrolltable.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'
import ztpCard from '@/nms/pages/configuration/components/ztp-card.vue'
import { CCMDBObject } from '@entcor/ebridge'

// Типы
interface DialogState {
  open: boolean
  addMode: boolean
  name: string | null
  data: any | null
}

interface TableColumn {
  title: string
  value: string
  lastArrayItem?: boolean
  type: string
  width: string
  dataKey?: string
  actions?: Array<{
    title: string
    tooltip: string
    icon: string
    color: string
    emit: string
  }>
}

interface TableRow {
  name?: string
  mac?: string
  template?: string
  status?: string[]
  [key: string]: any
}

interface TableData {
  columns: TableColumn[]
  rows: TableRow[]
}

interface OptionsColumns {
  [key: string]: { width: string }
}

interface OptionsData {
  columns: OptionsColumns
}

interface CabinetUnit {
  position: number
  name: string
  busy: boolean
}

interface CabinetData {
  usize?: number
  units?: CabinetUnit[]
}

interface TemplateItem {
  id?: string
  height?: number
  manufacturer?: string
  device_type?: string
  vendor_code?: string
  bridges?: {
    ztp?: {
      createcmdb?: {
        ssh?: any
        snmp?: any
      }
    }
  }
  [key: string]: any
}

interface ModelData {
  items: {
    cabinet: CabinetData
    template: TemplateItem | null
    files: any[]
  }
  obj: {
    name: string | null
    template: string | null
    ip: string | null
    mac: string | null
    mask: string | null
    gateway: string | null
    firmware: string | null
    position: number | null
    mount: string | null
    ssh: any | null
    snmp: any | null
  }
}

interface TreeNode {
  $id?: string
  id?: string
  name?: string
  cls?: string
  type?: string
  children?: TreeNode[]
  [key: string]: any
}

interface ExceptionsMap {
  [key: string]: string[]
}

interface DeviceResponse {
  data?: TableRow[]
  [key: string]: any
}

interface TemplateResponse {
  data?: any[]
  [key: string]: any
}

interface FilesResponse {
  data?: any[]
  [key: string]: any
}

export default Vue.extend({
  name: 'ZTP_CONFIGURATION',

  components: {
    scrollArea,
    scrollTable,
    svgIcon,
    ztpCard
  },

  props: {
    data: {
      type: Object as () => any,
      default: () => ({})
    },
  },

  data(): {
    show: boolean
    dialog: DialogState
    items: { server: string[] }
    model: ModelData
    includes: string[]
    exceptions: ExceptionsMap
    tree: TreeNode[]
    treeActive: TreeNode[]
    treeOpened: TreeNode[]
    activeParent: TreeNode | null
    options: OptionsData
    search: string
    table: TableData
  } {
    return {
      show: false,
      dialog: {
        open: false,
        addMode: false,
        name: null,
        data: null,
      },
      items: {
        server: ['enabled', 'disabled'],
      },
      model: {
        items: {
          cabinet: {},
          template: null,
          files: []
        },
        obj: {
          name: null,
          template: null,
          ip: null,
          mac: null,
          mask: null,
          gateway: null,
          firmware: null,
          position: null,
          mount: null,
          ssh: null,
          snmp: null,
        }
      },
      includes: ['location', 'cabinet'],
      exceptions: {
        device: ['tree_view'],
        module: ['tree_view'],
        location: ['type'],
      },
      tree: [],
      treeActive: [],
      treeOpened: [],
      activeParent: null,
      options: {
        columns: {
          text: { width: '40%' },
          timestamp: { width: '40%' },
          actions: { width: '40%' },
          check: { width: '20%' },
          check_dependence: { width: '5%' },
        },
      },
      search: '',
      table: {
        columns: [],
        rows: [],
      },
    }
  },

  computed: {
    getData(): any {
      return this.data
    },

    getItems(): CabinetUnit[] {
      return this.model?.items?.cabinet?.units || []
    },

    getFirmwares(): any[] {
      return this.model.items.files || []
    },

    getTree(): TreeNode[] {
      const filter = (arr: TreeNode[] | undefined, inc: string[], exc: ExceptionsMap): TreeNode[] => {
        return (arr || [])
          .map(n$ => {
            const n: TreeNode = {
              id: n$.id,
              $id: n$.$id,
              name: n$.name,
              cls: n$.cls,
              children: n$.children || [],
              type: n$.type || null
            }
            if (n.cls === 'cabinet') {
              delete n.children
            }
            if (!n.children?.length) {
              return n
            } else {
              n.children = filter(n.children, inc, exc)
              return n
            }
          })
          .filter((n): n is TreeNode => {
            if (n && n.cls && inc.includes(n.cls)) {
              if (Object.keys(exc).includes(n.cls)) {
                return !exc[n.cls].find(field => !n[field])
              }
              return true
            }
            return false
          })
      }
      const store = this.$store.state as any
      return filter(store.devices.tree, this.includes, this.exceptions)
    },

    getTable(): TableData {
      const t = this.$merge({}, this.table) as TableData

      if (this.search.length) {
        const searchLower = this.search.toLowerCase()
        t.rows = t.rows.filter(row => {
          return row.name?.toLowerCase().indexOf(searchLower) > -1 ||
                 row.mac?.toLowerCase().indexOf(searchLower) > -1 ||
                 row.template?.toLowerCase().indexOf(searchLower) > -1
        })
        return t
      }
      return this.table
    },

    getOptions(): OptionsData {
      return this.options
    },

    getDialogData(): any | null {
      return this.dialog.data
    },
  },

  watch: {
    treeActive: {
      handler(newVal: TreeNode[]): void {
        console.log('WATCH', this.$options.name, 'treeActive', newVal)
        if (newVal.length) {
          this.$set(this.model.obj, 'position', null)
          this.$set(this.model.obj, 'mount', null)
          this.loadParent(newVal[0])
        }
        if (!newVal?.length) {
          this.activeParent = null
        }
      },
      deep: true
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    setup(): void {
      this.loadDevices()
    },

    async loadDevices(): Promise<void> {
      try {
        const devices = await this.$bridge.customQuery('alarm', 'DHCP/getTable', {}, 'get') as DeviceResponse
        if (devices?.data?.length) {
          const columns: TableColumn[] = []
          const firstDevice = devices.data[0]
          Object.keys(firstDevice).forEach(key => {
            columns.push({
              title: key,
              value: key,
              lastArrayItem: true,
              type: 'text',
              width: '20%'
            })
          })

          const actionsColumn: TableColumn = {
            title: 'actions',
            value: '',
            dataKey: '',
            type: 'actions',
            actions: [
              {
                title: 'remove',
                tooltip: 'remove',
                icon: 'basket',
                color: 'red',
                emit: 'remove'
              }
            ],
            width: '4%'
          }
          if (columns.length) {
            columns.push(actionsColumn)
          }

          this.$set(this.table, 'columns', columns)

          const rows: TableRow[] = []
          devices.data.forEach(device => {
            if (device.mac?.length) {
              rows.push(device)
            }
          })
          this.$set(this.table, 'rows', rows)
        }
      } catch (error) {
        console.error('CATCH', this.$options.name, 'loadDevices error', error)
      }
    },

    async loadChildren(item: TreeNode): Promise<void> {
      await this.$store.dispatch('loadChildren', item)
    },

    async loadParent(item: TreeNode): Promise<void> {
      console.log(this.$options.name, 'loadParent', 'item', item)
      try {
        const query = {
          id: [item.$id],
          notNull: true,
          data: {
            namePath: true,
            children: {
              data: {
                children: true,
                namePath: true,
              },
              filter: { cls: { nin: ['folder'] } }
            },
          }
        }
        const obj = await this.$bridge.cmdbQuery(query) as any[]
        if (obj) {
          if (Array.isArray(obj)) {
            this.prepareParentData(obj[0])
          } else {
            this.prepareParentData(obj)
          }
        }
      } catch (error) {
        console.error('CATCH', this.$options.name, 'loadParent error', error)
      }
    },

    async prepareParentData(val: TreeNode): Promise<void> {
      console.log(this.$options.name, 'prepareParentData', 'val', val)
      if (val && val.cls !== 'cabinet') {
        this.activeParent = val
      }
      if (val && val.cls === 'cabinet') {
        const busyUnits: number[] = []
        if (val.children?.length) {
          val.children.forEach((child: any) => {
            const col = Math.ceil(child.height / 45)
            const startPosition = child.position
            for (let n = 0; n < col; n++) {
              const position = startPosition - n
              busyUnits.push(position)
            }
          })
        }

        this.$set(this.model.items.cabinet, 'usize', val.usize)
        const units: CabinetUnit[] = []
        for (let i = 1; i <= (val.usize || 0); i++) {
          units.push({
            position: i,
            name: `${this.$getTranslate('unit')} ${i}`,
            busy: busyUnits.includes(i)
          })
        }
        this.$set(this.model.items.cabinet, 'units', units)
        this.$set(this.model.obj, 'mount', 'front')
        this.activeParent = val
      }
    },

    async submit(): Promise<void> {
      console.log(this.$options.name, 'submit', 'this.model', this.model)
      console.log(this.$options.name, 'submit', 'this.activeParent', this.activeParent)

      const $parent = this.activeParent
      const cls$ = 'device'
      const data_$ = { ...this.model.obj, tree_view: 'true' }
      const data$: Record<string, any> = {}

      Object.keys(data_$).forEach(key => {
        if (data_$[key]) {
          data$[key] = data_$[key]
        }
      })
      if (data$.ip) {
        data$.ip_address = data$.ip
      }
      console.log(this.$options.name, 'submit', 'data$', data$)

      try {
        this.setLoader('submitDevice', true)
        const c = await $parent.createChild(cls$, data$)
        console.log(this.$options.name, 'submit', 'response', c)

        if (c) {
          const params = {
            id: c.$id,
            mac: data$.mac,
            ip_address: data$.ip,
            gateway: data$.gateway,
            mask: data$.mask,
            firmware: data$.firmware
          }
          const r = await this.$bridge.customQuery('alarm', 'DHCP/startZTP', params, 'put')
          if (r) {
            this.show = false
            this.reset()
          }
        }
        this.setLoader('submitDevice', false)
      } catch (err) {
        this.setLoader('submitDevice', false)
        this.$errorHandler(err)
      }
    },

    checkPosition(val: number): boolean {
      const deviceUnitSize = Math.ceil((this.model.items.template?.height || 0) / 45)
      let response = true

      for (let n = 0; n < deviceUnitSize; n++) {
        const position = val - n
        const unit = this.model.items.cabinet.units?.find(u => u.position === position)
        if (unit?.busy) {
          response = false
        }
      }

      if (!response) {
        this.$set(this.model.obj, 'position', null)
        this.$snotify.error('Размер устройства превышает размер доступного просторанства!', {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        })
      }
      return response
    },

    async onRowClick(val: TableRow): Promise<void> {
      console.log('ZTP_CONFIGURATION onRowClick', val)
      if (!val) {
        this.show = false
        this.reset()
        return
      }

      this.reset()
      try {
        const status = val.status
        if (status?.length && status[status.length - 1] === 'DHCP Discover') {
          this.$set(this.model.obj, 'name', `${val.template}_$${Math.round(Math.random() * 10000000000)}`)
          this.$set(this.model.obj, 'template', val.template)
          this.$set(this.model.obj, 'mac', val.mac)

          const template = await this.$bridge.getTemplates('device', { id: val.template }) as TemplateItem[]
          if (template?.length) {
            this.model.items.template = template[0]

            const files = await this.$bridge.customQuery('alarm', '/DHCP/findFiles', {
              manufacturer: template[0].manufacturer,
              device_type: template[0].device_type,
              vendor_code: template[0].vendor_code,
              type: 'image'
            }, 'get') as FilesResponse

            if (files?.data) {
              this.$set(this.model.items, 'files', files.data)
            }

            const ztpBridge = this.model.items.template.bridges?.ztp?.createcmdb
            if (ztpBridge?.ssh) {
              this.$set(this.model.obj, 'ssh', ztpBridge.ssh)
            }
            if (ztpBridge?.snmp) {
              this.$set(this.model.obj, 'snmp', ztpBridge.snmp)
            }
          }
          this.show = !this.show
        } else {
          this.$set(this.dialog, 'data', val)
          this.$set(this.dialog, 'open', true)
        }
      } catch (err) {
        console.error('CATCH', this.$options.name, 'onRowClick', err)
        this.$errorHandler(err)
      }
    },

    onReload(): void {
      console.log(this.$options.name, 'onReload')
      this.setup()
    },

    async onRemove(val: TableRow): Promise<void> {
      console.log('onRemove', val)
      this.$dialog.confirm({
        text: `Удалить ${val.mac}?`,
        title: 'Удаление',
        actions: {
          false: 'Отмена',
          true: {
            color: 'red',
            text: 'Удалить',
            handle: async () => {
              const d = await this.$bridge.customQuery('alarm', 'DHCP/deleteRecord', { mac: val.mac }, 'delete')
              console.log('removed', d)
              this.setup()
            }
          }
        }
      })
    },

    onDialogClose(): void {
      this.$set(this.dialog, 'data', null)
      this.$set(this.dialog, 'addMode', false)
      this.$set(this.dialog, 'open', false)
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    reset(): void {
      console.log(this.$options.name, 'reset')
      this.$set(this.model, 'items', {
        cabinet: {},
        template: null,
        files: []
      })
      this.$set(this.model, 'obj', {
        name: null,
        template: null,
        ip: null,
        mac: null,
        mask: null,
        gateway: null,
        firmware: null,
        position: null,
        mount: null,
        ssh: null,
        snmp: null,
      })

      this.tree = []
      this.treeActive = []
      this.treeOpened = []
      this.activeParent = null
    },
  },
})
</script>

<style lang="css" scoped>
</style>
